// extracted by mini-css-extract-plugin
module.exports = {"container":"resendActivationCodeForm_container__1W63-"};